import React from 'react'
import EditProfile from '../components/employeeProfile/EditProfile'

const Profile = () => {
  return (
    <div>
      <EditProfile />
    </div>
  )
}

export default Profile
